import React, { useState, useEffect } from 'react';
import { useAuth } from '../../Services/AuthContext';
import { useFetchEntitySingle } from '../../Services/fetchApi';
import { endpoints } from '../../utils/Constants';
import { adminShapeYup, clientDepartmentShapeYup, clientShapeYup, clientStaffShapeYup, supplierShapeYup } from '../../utils/YupShapes';
import ClientStaffDetail from '../Editors/ClientStaffDetail';
import ClientDepartmentDetail from '../Editors/ClientDepartmentDetail';
import ClientDetail from '../Editors/ClientDetail';
import Supplier from '../Editors/Supplier.tsx';
import FormContainer from '../Models/FormContainer';
import AdminDetail from '../Editors/AdminDetail';
import LoadingAnimation from '../Form/LoadingAnimation';
import { Button,Row,Col,Container } from 'reactstrap';
import { useAlert } from '../../Services/AlertContext';
import entities from '../../utils/entities';
import RouteModal from '../Models/RouteModal';
import useFetchSimple from '../../Services/useFetchSimple';

const Me = () => {
    const route = "/Me";
    const authItems = (auth) => {
         return [
            { validator: clientDepartmentShapeYup, title: "Department", name: "ClientDepartment", editor: <ClientDepartmentDetail route={route} />, getSingle: endpoints.getClientDepartment, id: auth.clientDepartmentId, update: endpoints.updateClientDepartment },
            { validator: clientStaffShapeYup, title: "User", name: "ClientStaff", editor: <ClientStaffDetail route={route} />, getSingle: endpoints.getClientStaff, id: auth.clientStaffId, update: endpoints.updateClientStaff },
            { validator: supplierShapeYup, title: "Supplier", name: "Supplier", editor: <Supplier route={route} />, getSingle: endpoints.getSupplier, id: auth.supplierId, update: endpoints.updateSupplier },
            { validator: clientShapeYup, title: "Client", name: "Client", editor: <ClientDetail route={route} />, getSingle: endpoints.getClientDetails, id: auth.clientId, update: endpoints.updateClient },
            { validator: adminShapeYup, title: "Admin", name: "Admin", editor: <AdminDetail route={route} />, getSingle: endpoints.getAdmin, id: auth.adminId, update: endpoints.updateAdmin }
        ]
    }
    const [items, setItems] = useState()
    const [item, setItem] = useState();
    const [get, setGet] = useState();
    const [details, loadingEntity, error, refresh] = useFetchEntitySingle(item, get,true);
    const fetch = useFetchSimple();
    const [loading, setLoading] = useState();
    const [auth] = useAuth();
    const alert = useAlert();
    useEffect(() => {
        auth && setItems(authItems(auth))
    }, [auth]);
    useEffect(() => {

        if (items) {
            const item = items.find(x => x.name === auth.role);
            setItem(item);

            setGet(item.id);
        }

    }, [items, auth, auth.Role]);
    const onsubmit = (values) => {
        const verb = 'Saving'
        const options = { method: 'POST', body: JSON.stringify(values) };
        setLoading(true);
        return fetch(item.update, options).then((result) => {
            var ret = result.body;
            if (ret.success) {
                const m = ret.messages;
                alert({

                    title: verb, body: <div>
                        <h5>Updated your account.</h5>
                        {m && m.length ? m.map(x => <p>{x}</p>) : null}
                    </div>
                    , onDismiss: () => {
                        setLoading(false);
                        refresh();
                    }
                });
            }
            else {
                alert({

                    title: "Error", body: <div>
                        <h5>{"Error - " + item.title}</h5>
                        {ret.messages && ret.messages.length ? ret.messages.map(x => <p>{x}</p>) : null}
                    </div>
                    , onDismiss: () => {

                        setLoading(false);

                    }
                });

            }


        }, (error) => {
            const errors = error?.body?.errors;
            const messages = errors ? Object.keys(errors).map((x, i) => {
                return <p key={i}>{errors[x].map(y => y)}</p>
            }) : null
            alert({
                title: 'Error saving' + item.title, body: <div>
                    <h3>Unexpected Result</h3>
                    {messages ? messages : JSON.stringify(error)}
                </div>
            });

            setLoading(false);
        }).catch((e) => {
            alert({ title: 'Error saving' + item.title, body: "Exception Result: " + e ? JSON.stringify(e) : 'No Error!' });
            setLoading(false);
        })
    };


    const [password, setPassword] = useState();


    return details ? <React.Fragment>
        <h1>{auth.title} Detail</h1>
        {error ? <h3>Error Loading Entity</h3> : null}
        {password ? <RouteModal appRoute={{ entity: entities.resetUserPassword }} parentEntityItem={details} route={route} onClose={() => setPassword(false)} /> : null}

        {loading || loadingEntity ? <LoadingAnimation /> : <FormContainer edit onSubmit={onsubmit} initialValues={{ ...details }} validationSchema={item.validator} >
            {item.editor}
            <Container>
                <Row>
                    <Col>
                        <Button className='float-right' onClick={() => setPassword(true)}>Set Password</Button>
                    </Col>
                </Row>
            </Container>
        </FormContainer>}

    </React.Fragment> : null

};

export default Me; 